import './../Status.scss';
import React from 'react';
import { useEffect, useRef, useState } from 'react'
import { useAppSelector } from '../../../../redux/hooks';
import { useDispatch } from 'react-redux';
import Plot from "react-plotly.js";
import { DataName, SensorNodeStatus } from '../../../../util/model';

interface Props {
    index: number;
}

export default function RelayTemperature(props: Props) {
    var layout_temp = {
        height: 30,
        margin: { t: 1, r: 1, l: 100, b: 15 },
        font: { color: "white", family: "Arial" },
        xaxis: {
            range:  [0, 130],
            autorange: false
        },
        plot_bgcolor :"gray",
        paper_bgcolor:"black"
    };
    var temp = {
        x: [-300],
        y: ['Relay Temp (C)'],
        type: 'bar',
        orientation: 'h',
        marker: {color: 'green', width: 2}
    }; 
    const [data_temp, setTempData] = useState([temp]);

    const dispatch = useDispatch();
    const layerData = useAppSelector(state => state.layerData);
    
    const SNTime = layerData.status.Time;
    const SNStatus = layerData.status.SensorNodeStatus;
    
    useEffect(() => {
        if((props.index >= 0) && (props.index < SNStatus.length)) {
            var temp = {
                y: ['Relay Temp (C)'],
                x: [SNStatus[props.index].Relay.Temperature],
                type: 'bar',
                orientation: 'h',
                marker: {color: 'green', width: 3}
            };
            if(SNStatus[props.index].Relay.Temperature < 40.0) {
                temp.marker.color = 'cyan';
            } else if(SNStatus[props.index].Relay.Temperature > 95.0) {
                temp.marker.color = 'orange';
            }  
            setTempData([temp]);  
        } else {
            var temp = {
                y: ['Relay Temp (C)'],
                x: [-300],
                type: 'bar',
                orientation: 'h',
                marker: {color: 'green', width: 3}
            };
            setTempData([temp]);  
        } 
    }, [SNTime, props.index]);
    
    return (
        <div>
            <Plot data={data_temp as any} layout={layout_temp} config={{displayModeBar: false}} useResizeHandler={true} style={{ width: '100%', height: '100%' }}/>
        </div>
    )
}
